import styled, { css } from 'styled-components'

import { Hexagon } from '../styles'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.xl}px;
    `}

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.xl2}px;
      padding: 0 ${theme.newSpaces.lg}px;
    `}
  `}
`

export const RightHexagon = styled(Hexagon)`
  display: none;
  left: -12%;
  top: 51%;

  ${({ theme }) => css`
    ${theme.below.laptopL`
      display: block;
    `}
  `}

  ${({ theme }) => theme.below.laptopML`
    display: none;
  `}
`
